<template>
  <DataTable
    :title="title"
    :rows="mappedRows"
    :cols-map="{
      [translate('Domain')]: 'domain',
      [translate('Requested')]: 'requested',
      [translate('Time Remaining')]: 'timeRemaining',
      [translate('Sent to')]: 'sentTo',
    }"
    :createable="!!userStore.hasPermission('login-policy:write')"
    style="border-width: 1px"
    :loading="loading"
  >
    <template #toolbar-actions></template>
    <template v-if="userStore.hasPermission('login-policy:write')" #actions="{row, rowid}">
      <td>
        <div class="align-middle d-inline-flex flex-shrink-0">
          <IconButton
            v-if="!row.expired && !row.validated"
            icon-name="material-symbols:check"
            class="text-success"
            @click="$emit('accept', rowid)"
          />
          <IconButton
            v-if="!row.validated"
            icon-name="material-symbols:delete-outline"
            class="text-danger"
            @click="$emit('delete', rowid)"
          />
        </div>
      </td>
    </template>
  </DataTable>
</template>
<script setup lang="ts">
import {DomainVerification} from '@/api/apolloPlatform/loginPolicy';
import {useLocalisation} from '@/composables/useLocalisation';

const userStore = useUserStore();
const {translate, displayTimeStamp} = useLocalisation();

defineEmits<{
  delete: [string];
  accept: [string];
}>();
const props = defineProps<{
  title: string;
  rows: DomainVerification[];
  loading: boolean;
}>();

const now = ref(new Date());
let interval: number | undefined;
onMounted(() => {
  interval = window.setInterval(() => {
    now.value = new Date();
  }, 1000);
});
onUnmounted(() => {
  clearInterval(interval);
});

function formatRemaining(date1: Date, date2: Date): string {
  const diff = date1.getTime() - date2.getTime();
  if (diff < 0) return translate('Expired');

  let remaining_msec = diff;
  const hours = Math.floor(remaining_msec / 1000 / 60 / 60);
  remaining_msec -= hours * 1000 * 60 * 60;
  const minutes = Math.floor(remaining_msec / 1000 / 60);
  remaining_msec -= minutes * 1000 * 60;
  const seconds = Math.floor(remaining_msec / 1000);
  remaining_msec -= seconds * 1000;
  return [
    hours.toString().padStart(2, '0'),
    minutes.toString().padStart(2, '0'),
    seconds.toString().padStart(2, '0'),
  ].join(':');
}

const mappedRows = computed(() =>
  props.rows.map((r) => ({
    ...r,
    requested: displayTimeStamp(r.created),
    expired: r.expired < now.value,
    timeRemaining: formatRemaining(r.expired, now.value),
  })),
);
</script>
